module.exports=[
  {
    "specifics": "Ban on indirect picketing upheld",
    "svg": "DL-1",
    "final_category": "Design/layout",
    "caption_popup": "This large headline is too big for the subject matter and isn't needed."
  },
  {
    "specifics": "",
    "svg": "RL-1",
    "final_category": "Racist language",
    "caption_popup": "We do not use the racist slur for Japanese Americans that is in the headline. We would not reduce local news of the U.S. government forcing its own citizens from their homes to a bottom corner of the front page. We would not use such innocuous language in the headline: These Bainbridge Island residents are not \"bidding it farewell,\" they are being taken away and forced to leave everything they own behind. \"Smiles\" reads like propaganda. Today, we would write a headline at the top of the page making it clear that Japanese American residents of  Bainbridge were being forced to leave their homes due to a federal policy."
  },
  {
    "specifics": "",
    "svg": "PS-1",
    "final_category": "Photo selection",
    "caption_popup": "We would not use this photo, which was 3 months old at time of publication and headlined with a racist slur. It is unrelated to the story and provides no useful context. Instead, we would move up the story about Bainbridge residents being forced to leave their homes and use two or three photos from Bainbridge Island, the ferry and the train as residents were being forced to leave."
  }
]